import React, { Component } from 'react';
import { Link } from 'react-router-dom';


import '../styles/blocks/footer.scss';

import logo from '../assets/logo.svg';
import face from '../assets/face.svg';
import goog from '../assets/goog.svg';
import twit from '../assets/twit.svg';
import tumb from '../assets/tumb.svg';


export default class Footer extends Component {

    render() {

        return (
          <div className="footer">
            <div className="top-content">
              <div className="left">
                <img src={ logo } alt='' />
                <span>VIVE&trade; Pro gets you closer to your game.<br/>Heighten your experiences. Enrich your <br/> adventures. Let the super-charged VIVE&trade;<br/> Pro lead the way.</span>
              </div>
              <div className="right">
                <div>
                  <span className="title">VIVE&trade; Products</span>
                  <span>VIVE&trade; Pro</span>
                  <span>VIVE&trade;</span>
                  <span>VIVE&trade; Ready</span>
                  <span>VIVE&trade; Store</span>
                </div>
                <div>
                  <span className="title">Info</span>
                  <span>About Us</span>
                  <span>Privacy Policy</span>
                  <span>Careers</span>
                  <span>Contact</span>
                </div>
                <div>
                  <span className="title">Support</span>
                  <span>Support Center</span>
                  <span>Help Desk</span>
                  <span>FAQs</span>
                </div>
              </div>
            </div>
            <div className="bottom-content">
              <div className="left">
                <img src={ face } alt='' />
                <img src={ goog } alt='' />
                <img src={ twit } alt='' />
                <img src={ tumb } alt='' />
              </div>
              <div className="right">
                © 2019 all rights reserved by kingsley seimodei
              </div>
            </div>
          </div>
        );
    }
}
